import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';

import { Screen } from '@/components/ScreenComponent';
import { ScreenNavBar } from '@/components/ScreenNavBar';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

const BULLETS = [
    'previous screen is fully hidden, nothing peeks through behind it',
    'dismiss with the back button or an edge swipe back',
    'use it for viewing or browsing only, not for edits or actions',
];

const FAKE_TRANSACTIONS = [
    { id: '1', label: 'Entry payout', date: 'Aug 12', amount: '+$24.50' },
    { id: '2', label: 'Deposit', date: 'Aug 10', amount: '+$50.00' },
    { id: '3', label: 'Entry fee', date: 'Aug 9', amount: '-$10.00' },
    { id: '4', label: 'Withdrawal', date: 'Aug 5', amount: '-$75.00' },
    { id: '5', label: 'Entry payout', date: 'Aug 3', amount: '+$12.25' },
    { id: '6', label: 'Deposit', date: 'Jul 29', amount: '+$100.00' },
    { id: '7', label: 'Entry fee', date: 'Jul 28', amount: '-$5.00' },
];

export const PresetPageDemoScreen = () => (
    <Screen>
        <ScreenNavBar title="Transaction History" closeIconMode="back" />
        <ScrollView contentContainerStyle={styles.scroll}>
            <Text variant="bodySmall" color={ds.colorToken.text.secondary} mb="s4">
                page, plain push, slides in from the right
            </Text>
            <Box mb="s16" gap="s4">
                {BULLETS.map(bullet => (
                    <Text key={bullet} variant="bodySmall" color={ds.colorToken.text.secondary}>
                        {`• ${bullet}`}
                    </Text>
                ))}
            </Box>
            <Text variant="labelSmall" color={ds.colorToken.text.tertiary} mb="s4">
                example below
            </Text>
            <Box borderRadius="r8" backgroundColor={ds.colorToken.background.neutral.subtler}>
                {FAKE_TRANSACTIONS.map(transaction => (
                    <Box
                        key={transaction.id}
                        flexDirection="row"
                        justifyContent="space-between"
                        alignItems="center"
                        padding="s16"
                    >
                        <Box>
                            <Text variant="labelMedium" color={ds.colorToken.text.primary}>
                                {transaction.label}
                            </Text>
                            <Text variant="bodySmaller" color={ds.colorToken.text.tertiary}>
                                {transaction.date}
                            </Text>
                        </Box>
                        <Text variant="labelMedium" color={ds.colorToken.text.primary}>
                            {transaction.amount}
                        </Text>
                    </Box>
                ))}
            </Box>
        </ScrollView>
    </Screen>
);

const styles = StyleSheet.create({
    scroll: {
        padding: 16,
        flexGrow: 1,
    },
});
